// extracted by mini-css-extract-plugin
export var deleteIcon = "_qu-5";
export var deleteOption = "_qu-3";
export var divider = "_qu-2";
export var downloadIcon = "_qu-4";
export var drawer = "_qu-0";
export var drawerFooter = "_qu-6";
export var drawerOpen = "_qu-1";
export var highlighted = "_qu-7";
export var lighterHighlight = "_qu-8";